export class TrichXuat {
    //Thông tin nkt
    // id: number;
    // madinhdanh: boolean;
    // ngaysinh: boolean;
    // dantoc: boolean;
    // sdt: boolean;
    // hoten: boolean;
    // namnhaphoc: boolean;
    // tongiao: boolean;
    // email: boolean;
    // gioitinh: boolean;
    // noisinh: boolean;
    // cmnd: boolean;
    // noiohiennay: boolean;

    // //Thông tin gia đình
    // hotencha: boolean;
    // nghenghiepcha: boolean;
    // namsinhcha: boolean;
    // sdtcha: boolean;

    // hotenme: boolean;
    // nghenghiepme: boolean;
    // namsinhme: boolean;
    // sdtme: boolean;

    // hotenngh: boolean;
    // nghenghiepngh: boolean;
    // namsinhngh: boolean;
    // sdtngh: boolean;
    // //Thông tin khuyết tật
    // chungnhankt: boolean;
    // coquancap: boolean;
    // khanangtuphucvu: boolean;
    // chitrahotronkt: boolean;
    // thoidiemphathiennkt: boolean;
    // hieuquahotroyte: boolean;
    // nhucaunkt: boolean;
    // doclapvekinhte: boolean;
    // nguyennhan: boolean;
    // thongtinyte: boolean;
    // trinhdohocvan: boolean;
    // dexuatkiennghi: boolean;
    // dangkt: boolean;
    // nguoichamsoc: boolean;
    // tinhtranggiaoduc: boolean;
    // hinhthuchoc: boolean;
    // mucdo: boolean;
    // dieukiensong: boolean;
    // giaotiepxahoi: boolean;
    // phuongthucgiaoduc: boolean;
    // chinhsachchedobaotro: boolean;
    // thunhaphangthang: boolean;
    // dichvuthamgia: boolean;
    // khanangnhanthuc: boolean;
    // mucphucapthang: boolean;
    // nguonthunhapchinh: boolean;
    // loaihinhgdthamgia: boolean;
    // cacvandevehanhvi: boolean;
    // ngaycap: boolean;
    // hotrothietbidacthu: boolean;
    // nhucapnkt: boolean;
    // loaihinhtochuc: boolean;
    // nghenghiep: boolean;
    // mucdoquantamgd: boolean;
    // //Quá trình học tập
    // lophoc: boolean;
    // giaovienphutrach: boolean;
    // giaovienchunhiem: boolean;
    // ketqua: boolean;
    constructor(
        public id?: number,
        public madinhdanh: boolean = false,
        public ngaysinh: boolean = false,
        public dantoc: boolean = false,
        public sdt: boolean = false,
        public hoten: boolean = false,
        public namnhaphoc: boolean = false,
        public tongiao: boolean = false,
        public email: boolean = false,
        public gioitinh: boolean = false,
        public noisinh: boolean = false,
        public cmnd: boolean = false,
        public noiohiennay: boolean = false,
     
         //Thông tin gia đình
        public hotencha: boolean = false,
        public nghenghiepcha: boolean = false,
        public namsinhcha: boolean = false,
        public sdtcha: boolean = false,
     
        public hotenme: boolean = false,
        public nghenghiepme: boolean = false,
        public namsinhme: boolean = false,
        public sdtme: boolean = false,
     
        public hotenngh: boolean = false,
        public nghenghiepngh: boolean = false,
        public namsinhngh: boolean = false,
        public sdtngh: boolean = false,
         //Thông tin khuyết tật
        public chungnhankt: boolean = false,
        public coquancap: boolean = false,
        public khanangtuphucvu: boolean = false,
        public chitrahotronkt: boolean = false,
        public thoidiemphathiennkt: boolean = false,
        public hieuquahotroyte: boolean = false,
        public nhucaunkt: boolean = false,
        public doclapvekinhte: boolean = false,
        public nguyennhan: boolean = false,
        public thongtinyte: boolean = false,
        public trinhdohocvan: boolean = false,
        public dexuatkiennghi: boolean = false,
        public dangkt: boolean = false,
        public nguoichamsoc: boolean = false,
        public tinhtranggiaoduc: boolean = false,
        public hinhthuchoc: boolean = false,
        public mucdo: boolean = false,
        public dieukiensong: boolean = false,
        public giaotiepxahoi: boolean = false,
        public phuongthucgiaoduc: boolean = false,
        public chinhsachchedobaotro: boolean = false,
        public thunhaphangthang: boolean = false,
        public dichvuthamgia: boolean = false,
        public khanangnhanthuc: boolean = false,
        public mucphucapthang: boolean = false,
        public nguonthunhapchinh: boolean = false,
        public loaihinhgdthamgia: boolean = false,
        public cacvandevehanhvi: boolean = false,
        public ngaycap: boolean = false,
        public hotrothietbidacthu: boolean = false,
        public nhucapnkt: boolean = false,
        public loaihinhtochuc: boolean = false,
        public nghenghiep: boolean = false,
        public mucdoquantamgd: boolean = false,
         //Quá trình học tập
        public lophoc: boolean = false,
        public giaovienphutrach: boolean = false,
        public giaovienchunhiem: boolean = false,
        public ketqua: boolean = false,
    ){

    }
} 